import { formatOfficeSelectorDisplayName } from "@Front/Utils/formatters";

const OFFICE_SELECTOR_SORT_LOCALE = "fr";

export type OfficeAffiliationSortable = {
	uid?: string | null;
	office_uid?: string | null;
	office?: { name?: string } | null;
};

/**
 * Alphabetical order on display label (fr), then office uid — same rule as office selector buttons (no PRIMARY/active-first).
 */
export function compareOfficeAffiliationsForSelectorDisplay(a: OfficeAffiliationSortable, b: OfficeAffiliationSortable): number {
	const uidA = a.office_uid ?? a.uid ?? "";
	const uidB = b.office_uid ?? b.uid ?? "";
	const labelA = formatOfficeSelectorDisplayName(a.office?.name ?? uidA);
	const labelB = formatOfficeSelectorDisplayName(b.office?.name ?? uidB);
	const byLabel = labelA.localeCompare(labelB, OFFICE_SELECTOR_SORT_LOCALE, { sensitivity: "base" });
	if (byLabel !== 0) {
		return byLabel;
	}
	return uidA.localeCompare(uidB, OFFICE_SELECTOR_SORT_LOCALE);
}

export function sortOfficeAffiliationsForSelectorDisplay<T extends OfficeAffiliationSortable>(items: T[]): T[] {
	return [...items].sort(compareOfficeAffiliationsForSelectorDisplay);
}
